export default __webpack_public_path__ + "d0999afdeac2177c6f848f0e6c02116c.png";